import { render } from "./popoverComponentJavascriptAction.vue?vue&type=template&id=727a5b9e&scoped=true"
import script from "./popoverComponentJavascriptAction.vue?vue&type=script&lang=js"
export * from "./popoverComponentJavascriptAction.vue?vue&type=script&lang=js"

import "./popoverComponentJavascriptAction.vue?vue&type=style&index=0&id=727a5b9e&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-727a5b9e"]])

export default __exports__